import { render, staticRenderFns } from "./ticket-all-table-item.vue?vue&type=template&id=d80d6a20&scoped=true&"
import script from "./ticket-all-table-item.vue?vue&type=script&lang=js&"
export * from "./ticket-all-table-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d6a20",
  null
  
)

export default component.exports